import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useClerk } from '@clerk/clerk-react';
import { LayoutGrid, PlusCircle, ChefHat, Wine, Settings, Globe, LogOut } from 'lucide-react';

export const POSSidebar = ({ viewMode, lang, setLang, startNewOrder, t }) => {
  const navigate = useNavigate();
  const { signOut } = useClerk();

  return (
    <aside className="w-20 bg-slate-950 py-6 flex flex-col items-center justify-between shrink-0 border-r border-slate-800" data-testid="pos-sidebar">
      <div className="space-y-6 flex flex-col items-center">
        <div className="w-12 h-12 bg-amber-500 rounded-2xl flex items-center justify-center text-slate-900 font-black text-lg shadow-lg shadow-amber-500/20">
          B
        </div>
        <nav className="flex flex-col space-y-2">
          <button
            onClick={() => startNewOrder('dashboard')}
            className={`p-3 rounded-xl transition-all ${viewMode === 'dashboard' ? 'bg-amber-500/20 text-amber-400' : 'text-slate-500 hover:text-white hover:bg-slate-800'}`}
            title={t.activeTables}
            data-testid="nav-dashboard"
          >
            <LayoutGrid size={22} />
          </button>
          <button
            onClick={() => startNewOrder('menu')}
            className={`p-3 rounded-xl transition-all ${viewMode === 'menu' ? 'bg-amber-500/20 text-amber-400' : 'text-slate-500 hover:text-white hover:bg-slate-800'}`}
            title={t.newOrder}
            data-testid="nav-new-order"
          >
            <PlusCircle size={22} />
          </button>
          <button
            onClick={() => navigate('/kitchen')}
            className="p-3 text-slate-500 hover:text-white hover:bg-slate-800 rounded-xl transition-all"
            title={t.kitchen}
            data-testid="nav-kitchen"
          >
            <ChefHat size={22} />
          </button>
          <button
            onClick={() => navigate('/beverages')}
            className="p-3 text-slate-500 hover:text-white hover:bg-slate-800 rounded-xl transition-all"
            title={t.bar}
            data-testid="nav-bar"
          >
            <Wine size={22} />
          </button>
          <button
            onClick={() => navigate('/admin')}
            className="p-3 text-slate-500 hover:text-white hover:bg-slate-800 rounded-xl transition-all"
            title={t.admin}
            data-testid="nav-admin"
          >
            <Settings size={22} />
          </button>
        </nav>
      </div>
      <div className="flex flex-col space-y-2">
        <button
          onClick={() => setLang(lang === 'en' ? 'vi' : 'en')}
          className="p-3 text-slate-500 hover:text-white hover:bg-slate-800 rounded-xl transition-all"
          title={t.language}
          data-testid="nav-language"
        >
          <Globe size={22} />
        </button>
        <button
          onClick={() => signOut()}
          className="p-3 text-red-400/70 hover:text-red-400 hover:bg-red-500/10 rounded-xl transition-all"
          title={t.logout}
          data-testid="nav-logout"
        >
          <LogOut size={22} />
        </button>
      </div>
    </aside>
  );
};
